import React, { useState, useEffect } from "react";
import { Grid, Icon, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Dialog, DialogTitle, DialogContent, DialogActions, MenuItem, Switch, FormControlLabel, TablePagination, Select, Checkbox, Chip } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import FormField from "layouts/pages/users/new-user/components/FormField";
import { Form, Formik } from "formik";
import DataTableHeadCell from "examples/Tables/DataTable/DataTableHeadCell";
import DataTableBodyCell from "examples/Tables/DataTable/DataTableBodyCell";
import { get, postNoResponse, post, getFile, postUploadNoResponse } from "utils/WebService";
import moment from "moment";
import MDInput from "components/MDInput";
import MDSelect from "components/MDSelect";
import MDSnackbar from "components/MDSnackbar";
import { toCurrency } from "utils/NumberUtils";
import { useUser } from "context/UserContext";

const formatCurrencyInput = (value) => {
    if (value === null || value === undefined || value === "") return "";
    let isNegative = value.toString().includes("-");
    if (typeof value === "number") {
        value = Math.abs(value).toFixed(2);
    }
    let numericValue = value.toString().replace(/\D/g, "");
    if (!numericValue) return "";
    numericValue = (numericValue / 100).toFixed(2) + "";
    numericValue = numericValue.replace(".", ",");
    numericValue = numericValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    return (isNegative ? "-R$ " : "R$ ") + numericValue;
};

const formatUncurrency = (value) => {
    if (value === null || value === undefined || value === "") return null;
    if (typeof value === 'number') return value;
    let isNegative = value.toString().includes("-");
    let cleanVal = value.toString().replace("-", "").replace("R$ ", "").trim();
    if (cleanVal.includes(",")) {
        cleanVal = cleanVal.replace(/\./g, "").replace(",", ".");
    }
    let num = parseFloat(cleanVal);
    return isNegative ? -num : num;
};

export default function Contratos({ formRef, recordId, isViewOnly, pendingContratos = [], setPendingContratos, isHonorariosTab = false, changeTab }) {
    const { userPerfils } = useUser();
    const isAdminOrSuporte = userPerfils && userPerfils.some(p => p?.tipoPerfil === 4 || p?.tipoPerfil === 6 || p?.nome === 'Administrador' || p?.nome === 'Suporte' || p === 'Administrador' || p === 'Suporte');
    const isFichaDevolvida = formRef?.current?.values?.status === 1;

    const [contratos, setContratos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isSavingForm, setIsSavingForm] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [marcacoes, setMarcacoes] = useState([]);
    const [selectedContrato, setSelectedContrato] = useState(null);
    const [apenasAtivos, setApenasAtivos] = useState(false);
    
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    
    const [successSB, setSuccessSB] = useState(false);
    const [errorSB, setErrorSB] = useState(false);
    const [sbMessage, setSbMessage] = useState("");
    
    const [openDevolverModal, setOpenDevolverModal] = useState(false);
    const [devolverObs, setDevolverObs] = useState("");
    const [devolverFile, setDevolverFile] = useState(null);
    const [isSubmittingDevolucao, setIsSubmittingDevolucao] = useState(false);
    const [contratoParaDevolver, setContratoParaDevolver] = useState(null);
    const [confirmAction, setConfirmAction] = useState({ open: false, title: "", message: "", onConfirm: null });

    const [simulacaoOpen, setSimulacaoOpen] = useState(false);
    const [simulacaoData, setSimulacaoData] = useState(null);
    const [simulacaoLoading, setSimulacaoLoading] = useState(false);
    const [dataBaseSimulacao, setDataBaseSimulacao] = useState(moment().format("YYYY-MM-DD"));

    const [acordoModalOpen, setAcordoModalOpen] = useState(false);
    const [acordoOpcaoSelecionada, setAcordoOpcaoSelecionada] = useState(null);
    const [acordoQtdParcelas, setAcordoQtdParcelas] = useState(1);
    const [acordoPrimeiroVencimento, setAcordoPrimeiroVencimento] = useState(moment().add(30, 'days').format("YYYY-MM-DD"));
    const [acordoPeriodicidade, setAcordoPeriodicidade] = useState(30);
    const [acordoValorEntrada, setAcordoValorEntrada] = useState("");
    const [acordoQtdEntrada, setAcordoQtdEntrada] = useState(1);
    const [acordoVencimentoEntrada, setAcordoVencimentoEntrada] = useState(moment().format("YYYY-MM-DD"));
    const [acordoParcelasGeradas, setAcordoParcelasGeradas] = useState([]);
    const [acordoEntradasDetalhadas, setAcordoEntradasDetalhadas] = useState([]);
    const [acordoMleList, setAcordoMleList] = useState([]);
    const [acordoComEntrada, setAcordoComEntrada] = useState(false);
    const [acordoIsExcecao, setAcordoIsExcecao] = useState(false);
    const [acordoFormaPagamento, setAcordoFormaPagamento] = useState("Boleto");
    const [acordoValorManual, setAcordoValorManual] = useState("");
    const [acordoLoading, setAcordoLoading] = useState(false);
    const [acordos, setAcordos] = useState([]);
    
    // Honorários Configuration State
    const [gerarHO, setGerarHO] = useState(false);
    const [hoPercentual, setHoPercentual] = useState(20);
    const [hoTipo, setHoTipo] = useState(1);
    const hoTiposList = [
        { id: 1, label: 'Sucumbenciais' },
        { id: 2, label: 'Contratuais' },
        { id: 3, label: 'Iniciais' },
        { id: 4, label: 'Finais' },
        { id: 5, label: 'Outros' }
    ];
    
    const [confirmCancelOpen, setConfirmCancelOpen] = useState(false);
    const [pendingOpcao, setPendingOpcao] = useState(null);
    const [selectedContratos, setSelectedContratos] = useState([]);

    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [contratoToDelete, setContratoToDelete] = useState(null);

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            setSelectedContratos(contratosFiltrados.map(c => c.id));
        } else {
            setSelectedContratos([]);
        }
    };

    const handleCheckboxClick = (event, id) => {
        event.stopPropagation();
        setSelectedContratos(prev => 
            prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
        );
    };

    const showSnackbar = (msg, isSuccess) => {
        setSbMessage(msg);
        if (isSuccess) setSuccessSB(true);
        else setErrorSB(true);
    };

    const fetchContratos = () => {
        if (!recordId) {
            setContratos(pendingContratos || []);
            return;
        }
        setLoading(true);
        Promise.all([
            get(`/contratos/list/${recordId}`),
            get(`/acordo/list/${recordId}`)
        ]).then(([contratosRes, acordosRes]) => {
            setContratos(contratosRes || []);
            setAcordos(acordosRes || []);
        }).catch(() => {
            showSnackbar("Erro ao carregar contratos ou acordos", false);
        }).finally(() => setLoading(false));
    };

    useEffect(() => {
        fetchContratos();
        get("/marcacoes").then((res) => {
            const list = res.list || res.data || (Array.isArray(res) ? res : []);
            setMarcacoes(list.filter(m => m.cvAlvo === 2 || m.cvAlvo === 3));
        }).catch(() => setMarcacoes([]));
    }, [recordId, pendingContratos]);

    const handleMainValorEntradaChange = (valStr) => {
        const formatted = formatCurrencyInput(valStr);
        setAcordoValorEntrada(formatted);
        const val = formatUncurrency(formatted) || 0;
        const qty = parseInt(acordoQtdEntrada) || 0;
        if (qty > 0) {
            const valEach = val / qty;
            setAcordoEntradasDetalhadas(prev => {
                const list = [...prev];
                return list.map(item => ({
                    ...item,
                    valor: formatCurrencyInput(valEach)
                }));
            });
        }
    };

    useEffect(() => {
        if (!acordoComEntrada) {
            setAcordoEntradasDetalhadas([]);
            return;
        }
        const qty = parseInt(acordoQtdEntrada) || 0;
        if (qty <= 0) {
            setAcordoEntradasDetalhadas([]);
            return;
        }
        
        setAcordoEntradasDetalhadas(prev => {
            if (qty === 1) {
                const existingMle = prev[0]?.isMle || false;
                return [{
                    valor: acordoValorEntrada,
                    vencimento: acordoVencimentoEntrada,
                    isMle: existingMle
                }];
            } else {
                if (prev.length !== qty) {
                    const baseVal = formatUncurrency(acordoValorEntrada) || 0;
                    const valEach = qty > 0 ? baseVal / qty : 0;
                    const list = [];
                    let curVenc = moment(acordoVencimentoEntrada || undefined);
                    const period = parseInt(acordoPeriodicidade) || 30;
                    
                    for (let i = 0; i < qty; i++) {
                        if (prev[i]) {
                            list.push(prev[i]);
                        } else {
                            list.push({
                                valor: formatCurrencyInput(valEach),
                                vencimento: curVenc.format("YYYY-MM-DD"),
                                isMle: false
                            });
                        }
                        curVenc.add(period, 'days');
                    }
                    return list;
                }
                return prev;
            }
        });
    }, [acordoComEntrada, acordoQtdEntrada, acordoValorEntrada, acordoVencimentoEntrada, acordoPeriodicidade]);

    const handleOpenDialog = (contrato = null) => {
        setSelectedContrato(contrato);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setSelectedContrato(null);
        setOpenDialog(false);
    };

    const handleSubmit = (values, { setSubmitting }) => {
        const payload = {
            id: values.id,
            idDevedor: recordId,
            titulo: values.titulo,
            descricao: values.descricao,
            parcela: values.parcela,
            vencimento: values.vencimento,
            valorOriginal: formatUncurrency(values.valorOriginal),
            saldo: formatUncurrency(values.saldo),
            situacao: values.situacao,
            marcacoesIds: values.marcacoesIds,
            idCarteira: values.carteiraId,
            isHonorario: isHonorariosTab,
        };

        if (!recordId) {
            if (values.id) {
                payload.id = values.id;
                const updated = pendingContratos.map(c => c.id === values.id ? payload : c);
                setPendingContratos(updated);
            } else {
                payload.id = `temp_${Date.now()}`;
                setPendingContratos([...pendingContratos, payload]);
            }
            showSnackbar("Contrato salvo provisoriamente!", true);
            handleCloseDialog();
            setSubmitting(false);
            return;
        }

        postNoResponse("/contratos/save", payload)
            .then(() => {
                showSnackbar("Contrato salvo com sucesso!", true);
                fetchContratos();
                handleCloseDialog();
            })
            .catch(() => showSnackbar("Erro ao salvar contrato", false))
            .finally(() => setSubmitting(false));
    };

    const handleReativarContratoDireto = (contrato) => {
        setConfirmAction({
            open: true,
            title: "Reativar Contrato",
            message: `Deseja realmente reativar o contrato ${contrato.titulo}?`,
            onConfirm: () => {
                postNoResponse(`/contratos/reativar/${contrato.id}`, {})
                    .then(() => {
                        showSnackbar("Contrato reativado com sucesso!", true);
                        fetchContratos();
                    })
                    .catch(err => {
                        showSnackbar("Erro ao reativar contrato", false);
                    });
            }
        });
    };

    const handleReativarLote = () => {
        const reativarIds = selectedContratos.filter(id => {
            const c = contratos.find(x => x.id === id);
            return c && c.situacao === 4;
        });
        if (reativarIds.length === 0) {
            showSnackbar("Nenhum contrato devolvido selecionado para reativar.", false);
            return;
        }
        setConfirmAction({
            open: true,
            title: "Reativar Selecionados",
            message: `Deseja reativar os ${reativarIds.length} contratos devolvidos selecionados?`,
            onConfirm: () => {
                postNoResponse(`/contratos/reativar-lote`, reativarIds)
                    .then(() => {
                        showSnackbar("Contratos reativados com sucesso!", true);
                        fetchContratos();
                        setSelectedContratos([]);
                    })
                    .catch(err => {
                        showSnackbar("Erro ao reativar contratos", false);
                    });
            }
        });
    };

    const handleDeleteClick = (contrato) => {
        setContratoToDelete(contrato);
        setDeleteDialogOpen(true);
    };

    const confirmDelete = () => {
        if (!contratoToDelete) return;
        
        if (!recordId || contratoToDelete.id.toString().startsWith("temp_")) {
            const updatedPending = pendingContratos.filter(c => c.id !== contratoToDelete.id);
            setPendingContratos(updatedPending);
            setContratos(updatedPending);
            showSnackbar("Contrato removido com sucesso!", true);
            setDeleteDialogOpen(false);
            setContratoToDelete(null);
            return;
        }

        postNoResponse("/contratos/delete", { id: contratoToDelete.id })
            .then(() => {
                showSnackbar("Contrato excluído com sucesso!", true);
                fetchContratos();
            })
            .catch(() => {
                showSnackbar("Erro ao excluir contrato. Pode haver acordos vinculados.", false);
            })
            .finally(() => {
                setDeleteDialogOpen(false);
                setContratoToDelete(null);
            });
    };

    const handleDevolverDireto = (contrato) => {
        setConfirmAction({
            open: true,
            title: "Devolver Contrato",
            message: `Deseja realmente devolver o contrato/título ${contrato.titulo}?`,
            onConfirm: async () => {
                try {
                    await postNoResponse(`/contratos/devolver/${contrato.id}`, {});
                    showSnackbar("Contrato devolvido com sucesso!", true);
                    fetchContratos();
                } catch (e) {
                    showSnackbar("Erro ao devolver contrato", false);
                }
            }
        });
    };

    const handleOpenSolicitarDevolucao = (contrato) => {
        setContratoParaDevolver(contrato);
        setDevolverObs("");
        setDevolverFile(null);
        setOpenDevolverModal(true);
    };

    const getSituacaoLabel = (sit) => {
        switch (sit) {
            case 1: return "Aberto";
            case 2: return "Baixado Parcial";
            case 3: return "Liquidado";
            case 4: return "Devolvida";
            default: return "Aberto";
        }
    };

    const handleSimularCalculoDevedor = () => {
        if (isFichaDevolvida) {
            alert("Não é possível simular acordos para fichas Devolvidas.");
            return;
        }
        if (contratos.length === 0) {
            showSnackbar("Não há contratos para simular.", false);
            return;
        }

        setSimulacaoLoading(true);
        let query = `dataBase=${dataBaseSimulacao}`;
        if (selectedContratos.length > 0) {
            query += `&contratosIds=${selectedContratos.join(',')}`;
        }
        
        get(`/campanha/simular-calculo-devedor/${recordId}?${query}`)
            .then(res => {
                setSimulacaoData(res);
                setSimulacaoOpen(true);
            })
            .catch(err => {
                showSnackbar(err.message || "Erro ao simular cálculo ou nenhuma campanha ativa.", false);
            })
            .finally(() => setSimulacaoLoading(false));
    };

    const proceedOpenAcordoModal = (opcao) => {
        setAcordoOpcaoSelecionada(opcao);
        setAcordoQtdParcelas(opcao.parcelaMinima);
        setAcordoPrimeiroVencimento(moment().add(30, 'days').format("YYYY-MM-DD"));
        setAcordoPeriodicidade(30);
        setAcordoValorEntrada("");
        setAcordoQtdEntrada(1);
        setAcordoVencimentoEntrada(moment().format("YYYY-MM-DD"));
        setAcordoEntradasDetalhadas([]);
        setAcordoMleList([]);
        setAcordoParcelasGeradas([]);
        setAcordoComEntrada(false);
        setAcordoIsExcecao(false);
        setAcordoFormaPagamento("Boleto");
        setAcordoValorManual("");
        setAcordoModalOpen(true);
    };

    const handleOpenAcordoModal = (opcao) => {
        if (isFichaDevolvida) {
            alert("Não é possível simular acordos para fichas Devolvidas.");
            return;
        }
        const checkContratos = selectedContratos.length > 0 ? selectedContratos : contratos.map(c => c.id);
        const hasActive = acordos.some(a => 
            a.situacao === 1 && a.contratos.some(c => checkContratos.includes(c.idContrato))
        );
        if (hasActive) {
            setPendingOpcao(opcao);
            setConfirmCancelOpen(true);
            return;
        }
        proceedOpenAcordoModal(opcao);
    };

    const proceedOpenAcordoManual = () => {
        setAcordoOpcaoSelecionada({
            isManual: true,
            totalComDesconto: simulacaoData.totalAtualizado,
            parcelaMinima: 1,
            parcelaMaxima: 999
        });
        setAcordoQtdParcelas(1);
        setAcordoPrimeiroVencimento(moment().add(30, 'days').format("YYYY-MM-DD"));
        setAcordoPeriodicidade(30);
        setAcordoValorEntrada("");
        setAcordoQtdEntrada(1);
        setAcordoVencimentoEntrada(moment().format("YYYY-MM-DD"));
        setAcordoEntradasDetalhadas([]);
        setAcordoMleList([]);
        setAcordoParcelasGeradas([]);
        setAcordoComEntrada(false);
        setAcordoIsExcecao(false);
        setAcordoFormaPagamento("Boleto");
        setAcordoValorManual(formatCurrencyInput(simulacaoData.totalAtualizado));
        setAcordoModalOpen(true);
    };

    const handleOpenAcordoManual = () => {
        if (isFichaDevolvida) {
            alert("Não é possível simular acordos para fichas Devolvidas.");
            return;
        }
        const checkContratos = selectedContratos.length > 0 ? selectedContratos : contratos.map(c => c.id);
        const hasActive = acordos.some(a => 
            a.situacao === 1 && a.contratos.some(c => checkContratos.includes(c.idContrato))
        );
        if (hasActive) {
            setPendingOpcao({ isManual: true });
            setConfirmCancelOpen(true);
            return;
        }
        proceedOpenAcordoManual();
    };

    const handleCalcularCronograma = () => {
        let total = acordoOpcaoSelecionada.isManual ? (formatUncurrency(acordoValorManual) || 0) : acordoOpcaoSelecionada.totalComDesconto;
        let entrada = acordoComEntrada ? (formatUncurrency(acordoValorEntrada) || 0) : 0;
        let saldo = total - entrada;
        
        let parcelas = [];
        let numParcela = 0;
        
        if (acordoComEntrada && acordoEntradasDetalhadas.length > 0) {
            for (let i = 0; i < acordoEntradasDetalhadas.length; i++) {
                const ent = acordoEntradasDetalhadas[i];
                parcelas.push({
                    numeroParcela: ++numParcela,
                    isEntrada: true,
                    isMle: acordoMleList[i] || false,
                    valorParcela: formatUncurrency(ent.valor) || 0,
                    vencimento: ent.vencimento
                });
            }
        } else if (entrada > 0) {
            let valEntrada = entrada / acordoQtdEntrada;
            let curVencimento = moment(acordoVencimentoEntrada);
            for (let i = 0; i < acordoQtdEntrada; i++) {
                parcelas.push({
                    numeroParcela: ++numParcela,
                    isEntrada: true,
                    isMle: acordoMleList[i] || false,
                    valorParcela: valEntrada,
                    vencimento: curVencimento.format("YYYY-MM-DD")
                });
                curVencimento.add(acordoPeriodicidade, 'days');
            }
        }
        
        if (acordoQtdParcelas > 0) {
            let valParcela = saldo / acordoQtdParcelas;
            let curVencimento = moment(acordoPrimeiroVencimento);
            for (let i = 0; i < acordoQtdParcelas; i++) {
                parcelas.push({
                    numeroParcela: ++numParcela,
                    isEntrada: false,
                    valorParcela: valParcela,
                    vencimento: curVencimento.format("YYYY-MM-DD")
                });
                curVencimento.add(acordoPeriodicidade, 'days');
            }
        }
        
        setAcordoParcelasGeradas(parcelas);
    };

    const handleChangeParcela = (idx, field, value) => {
        let novas = [...acordoParcelasGeradas];
        novas[idx][field] = value;
        setAcordoParcelasGeradas(novas);
    };

    const handleGerarAcordo = () => {
        const isAvista = acordoOpcaoSelecionada && acordoOpcaoSelecionada.parcelaMaxima === 1 && acordoOpcaoSelecionada.parcelaMinima === 1;
        const totalBase = acordoOpcaoSelecionada.isManual ? (formatUncurrency(acordoValorManual) || 0) : acordoOpcaoSelecionada.totalComDesconto;
        
        // Verifica regra de campanha para simulação manual
        if (acordoOpcaoSelecionada.isManual && !acordoIsExcecao) {
            let minAllowedValue = simulacaoData.totalAtualizado;
            const totalParcelasConfiguradas = acordoQtdParcelas + (acordoComEntrada && formatUncurrency(acordoValorEntrada) > 0 ? acordoQtdEntrada : 0);
            
            if (simulacaoData && simulacaoData.opcoesParcelamento) {
                const rule = simulacaoData.opcoesParcelamento.find(r => totalParcelasConfiguradas >= r.parcelaMinima && totalParcelasConfiguradas <= r.parcelaMaxima);
                if (rule) {
                    minAllowedValue = rule.totalComDesconto;
                }
            }
            if (totalBase < minAllowedValue - 0.10) {
                showSnackbar(`Valor mínimo para ${totalParcelasConfiguradas}x pela campanha é ${toCurrency(minAllowedValue)}. Marque "Exceção" se deseja prosseguir.`, false);
                return;
            }
        }

        let finalParcelas = [];
        if (isAvista) {
            finalParcelas = [{
                numeroParcela: 1,
                valorParcela: totalBase,
                vencimento: acordoPrimeiroVencimento,
                cbEntrada: false,
                cbMle: false
            }];
        } else {
            if (acordoParcelasGeradas.length === 0) {
                showSnackbar("Gere o cronograma primeiro", false);
                return;
            }
            
            let sum = 0;
            for (let p of acordoParcelasGeradas) {
                let v = formatUncurrency(p.valorParcela);
                if (v === null) v = Number(p.valorParcela);
                sum += v;
            }
            
            if (sum < totalBase - 0.10) {
                showSnackbar("A soma das parcelas não pode ser menor que o Total a Pagar do acordo.", false);
                return;
            }
            
            finalParcelas = acordoParcelasGeradas.map((p, i) => ({
                numeroParcela: i + 1,
                valorParcela: formatUncurrency(p.valorParcela) !== null ? formatUncurrency(p.valorParcela) : p.valorParcela,
                vencimento: p.vencimento,
                cbEntrada: p.isEntrada || false,
                cbMle: p.isMle || false
            }));
        }
        
        setAcordoLoading(true);
        const checkContratos = selectedContratos.length > 0 ? selectedContratos : contratos.map(c => c.id);
        const hasActive = acordos.some(a => 
            a.situacao === 1 && a.contratos.some(c => checkContratos.includes(c.idContrato))
        );
        
        const payload = {
            idDevedor: recordId,
            cancelarAcordoAtual: hasActive,
            idCampanha: simulacaoData?.campanhaId || null,
            valorOriginalTotal: simulacaoData.valorOriginal,
            valorAcordoTotal: totalBase,
            descontoAplicado: simulacaoData.totalAtualizado - totalBase,
            multaAplicada: simulacaoData.valorMulta,
            jurosAplicados: simulacaoData.valorJuros,
            correcaoAplicada: simulacaoData.valorCorrecao,
            honorariosAplicados: simulacaoData.valorHonorarios,
            formaPagamento: acordoFormaPagamento,
            qtdParcelas: finalParcelas.length,
            primeiroVencimento: finalParcelas[0].vencimento,
            parcelas: finalParcelas,
            contratos: contratos.filter(c => (c.situacao === 1 || c.situacao === 2) && (selectedContratos.length === 0 || selectedContratos.includes(c.id))).map(c => ({
                idContrato: c.id,
                titulo: c.titulo,
                valorNegociado: c.saldo // Simplificado
            })),
            gerarDividaHonorarios: gerarHO,
            percentualHonorarios: gerarHO ? hoPercentual : null,
            tipoHonorario: gerarHO ? hoTipo : null
        };

        post("/acordo/save", payload)
            .then((response) => {
                showSnackbar("Acordo gerado com sucesso! Vá para a aba Acordos para visualizar.", true);
                setAcordoModalOpen(false);
                setSimulacaoOpen(false);
                fetchContratos(); // Atualiza a lista
                
                if (response && response.idHonorarioGerado) {
                    setConfirmAction({
                        open: true,
                        title: "Honorários Gerados",
                        message: "A dívida de Honorários foi criada com sucesso! Deseja iniciar o acordo dos honorários agora?",
                        onConfirm: () => {
                            if (changeTab) changeTab(6); // Switch to Honorarios Tab
                            setLoading(true);
                            post("/devedor/simular-calculo", {
                                id: recordId,
                                contratosIds: [response.idHonorarioGerado],
                                dataBase: moment().format("YYYY-MM-DD")
                            }).then(simRes => {
                                setSelectedContratos([response.idHonorarioGerado]);
                                setSimulacaoData(simRes);
                                setSimulacaoOpen(true);
                            }).catch(err => {
                                showSnackbar("Erro ao simular honorário: " + (err.message || "Erro desconhecido"), false);
                            }).finally(() => setLoading(false));
                        }
                    });
                } else if (acordoFormaPagamento === 'Boleto' && response && response.idPrimeiraParcela) {
                    setConfirmAction({
                        open: true,
                        title: "Acordo Gerado",
                        message: "Acordo gerado com sucesso! Deseja emitir o boleto da 1ª parcela agora?",
                        onConfirm: () => {
                            setLoading(true);
                            getFile(`/acordo/parcela/boleto/${response.idPrimeiraParcela}`, "boleto.pdf")
                                .catch(err => showSnackbar(err.message || "Erro ao emitir boleto", false))
                                .finally(() => setLoading(false));
                        }
                    });
                }
            })
            .catch((err) => {
                showSnackbar(err.message || "Erro ao gerar acordo", false);
            })
            .finally(() => setAcordoLoading(false));
    };

    const [migracaoModalOpen, setMigracaoModalOpen] = useState(false);
    const [carteirasOptions, setCarteirasOptions] = useState([]);
    const [usuariosOptions, setUsuariosOptions] = useState([]);
    const [statusFichaOptions, setStatusFichaOptions] = useState([]);
    const [selectedCarteiraMigracao, setSelectedCarteiraMigracao] = useState("");
    const [selectedUsuarioMigracao, setSelectedUsuarioMigracao] = useState("");
    const [selectedStatusMigracao, setSelectedStatusMigracao] = useState("");

    useEffect(() => {
        get("/carteira/list-all").then(res => {
            if (res && res.list) {
                setCarteirasOptions(res.list);
            }
        }).catch(() => console.error("Erro ao carregar carteiras"));
    }, []);

    useEffect(() => {
        if (!selectedCarteiraMigracao) {
            setUsuariosOptions([]);
            return;
        }
        get(`/users/list-all-operators?carteiraId=${selectedCarteiraMigracao}`).then(res => {
            if (res && res.list) {
                setUsuariosOptions(res.list);
            } else {
                setUsuariosOptions([]);
            }
        }).catch(() => setUsuariosOptions([]));
    }, [selectedCarteiraMigracao]);

    const handleOpenMigracaoModal = () => {
        if (selectedContratos.length === 0) {
            showSnackbar("Selecione ao menos um contrato para migrar.", false);
            return;
        }
        setLoading(true);
        Promise.all([
            get("/carteira/list-all"),
            get("/status-ficha/list-all")
        ]).then(([cartRes, statusRes]) => {
            setCarteirasOptions(cartRes?.list || []);
            setStatusFichaOptions(statusRes?.list || []);
            setSelectedCarteiraMigracao("");
            setSelectedUsuarioMigracao("");
            setSelectedStatusMigracao("");
            setMigracaoModalOpen(true);
        }).catch(() => showSnackbar("Erro ao carregar opções para migração", false))
        .finally(() => setLoading(false));
    };

    const handleConfirmMigracao = () => {
        if (!selectedCarteiraMigracao) {
            showSnackbar("Selecione uma carteira de destino.", false);
            return;
        }
        setLoading(true);
        postNoResponse("/devedor/testar-migracao", { 
            id: recordId, 
            contratosIds: selectedContratos, 
            carteiraId: selectedCarteiraMigracao,
            usuarioId: selectedUsuarioMigracao,
            statusFichaId: selectedStatusMigracao
        })
            .then(() => {
                showSnackbar("Migração concluída com sucesso! Atualize a página.", true);
                setMigracaoModalOpen(false);
                setSelectedContratos([]);
                fetchContratos();
            })
            .catch((err) => {
                showSnackbar(err.message || "Erro na migração", false);
            })
            .finally(() => setLoading(false));
    };

    const contratosBase = isHonorariosTab ? contratos.filter(c => c.isHonorario === true) : contratos.filter(c => c.isHonorario !== true);
    const contratosFiltrados = apenasAtivos ? contratosBase.filter(c => c.situacao === 1 || c.situacao === 2) : contratosBase;

    return (
        <MDBox mt={2}>
            <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <MDBox display="flex" alignItems="center">
                    <FormControlLabel 
                        control={
                            <Switch 
                                checked={apenasAtivos}
                                onChange={(e) => {
                                    setApenasAtivos(e.target.checked);
                                    setPage(0);
                                }}
                                color="info"
                            />
                        } 
                        label={<MDTypography variant="button" fontWeight="regular" color="text" sx={{ cursor: "pointer", userSelect: "none", ml: -0.5 }}>Apenas Ativos</MDTypography>}
                        sx={{ margin: 0 }}
                    />
                </MDBox>
                {!isViewOnly && (
                    <MDBox display="flex">
                        {recordId && (
                            <MDButton variant="outlined" color="warning" size="small" onClick={handleOpenMigracaoModal} sx={{ mr: 1 }}>
                                <Icon sx={{ mr: 1 }}>autorenew</Icon> Migrar Carteira
                            </MDButton>
                        )}
                        {recordId && isAdminOrSuporte && selectedContratos.some(id => contratos.find(c => c.id === id)?.situacao === 4) && (
                            <MDButton variant="contained" color="success" size="small" onClick={handleReativarLote} sx={{ mr: 1 }}>
                                <Icon sx={{ mr: 1 }}>restore</Icon> Reativar Selecionados
                            </MDButton>
                        )}
                        <MDButton variant="contained" color="info" size="small" onClick={() => handleOpenDialog()}>
                            <Icon sx={{ mr: 1 }}>add</Icon> Novo Contrato
                        </MDButton>
                    </MDBox>
                )}
            </MDBox>

            <TableContainer sx={{ boxShadow: "none" }}>
                <Table>
                    <MDBox component="thead">
                        <TableRow>
                            <TableCell padding="checkbox" align="center" sx={{ borderBottom: "1px solid #f0f2f5" }}>
                                <Checkbox 
                                    color="primary" 
                                    indeterminate={selectedContratos.length > 0 && selectedContratos.length < contratosFiltrados.length}
                                    checked={contratosFiltrados.length > 0 && selectedContratos.length === contratosFiltrados.length}
                                    onChange={handleSelectAllClick} 
                                />
                            </TableCell>
                            <DataTableHeadCell width="auto" sorted={false}>Título</DataTableHeadCell>
                            <DataTableHeadCell width="auto" sorted={false}>Carteira</DataTableHeadCell>
                            <DataTableHeadCell width="auto" sorted={false}>Descrição</DataTableHeadCell>
                            <DataTableHeadCell width="auto" sorted={false}>Parcela</DataTableHeadCell>
                            <DataTableHeadCell width="auto" sorted={false}>Vencimento</DataTableHeadCell>
                            <DataTableHeadCell width="auto" sorted={false}>Saldo</DataTableHeadCell>
                            <DataTableHeadCell width="auto" sorted={false}>Situação</DataTableHeadCell>
                            {(!isViewOnly || recordId) && <DataTableHeadCell width="auto" align="center" sorted={false}>Ações</DataTableHeadCell>}
                        </TableRow>
                    </MDBox>
                    <TableBody>
                        {contratosFiltrados.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={(!isViewOnly || recordId) ? 9 : 8} align="center" sx={{ py: 3, borderBottom: "none" }}>
                                    <MDTypography variant="caption" color="text">Nenhum contrato encontrado.</MDTypography>
                                </TableCell>
                            </TableRow>
                        )}
                        {contratosFiltrados.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => {
                            const rowId = item.id || `temp_idx_${index}`;
                            const isSelected = selectedContratos.includes(rowId);
                            return (
                                <TableRow key={rowId} selected={isSelected} hover>
                                    <TableCell padding="checkbox" align="center" sx={{ borderBottom: "1px solid #f0f2f5" }}>
                                        <Checkbox 
                                            color="primary" 
                                            checked={isSelected}
                                            onChange={(e) => {
                                                setSelectedContratos(prev => 
                                                    prev.includes(rowId) ? prev.filter(i => i !== rowId) : [...prev, rowId]
                                                );
                                            }}
                                        />
                                    </TableCell>
                                    <DataTableBodyCell isProcess={true}>
                                        <MDBox display="flex" alignItems="center">
                                            <MDTypography variant="caption" fontWeight="regular" color="text">{item.titulo}</MDTypography>
                                            {item.numeroProcesso && (
                                                <Chip label={`Processo: ${item.numeroProcesso}`} size="small" color="info" variant="outlined" sx={{ ml: 1, height: 20, fontSize: '0.65rem' }} />
                                            )}
                                        </MDBox>
                                    </DataTableBodyCell>
                                    <DataTableBodyCell isProcess={true}>
                                        {item.nomeCarteira ? (
                                            <MDTypography variant="caption" fontWeight="medium" color="info">
                                                {item.nomeCarteira}
                                            </MDTypography>
                                        ) : (
                                            <MDTypography variant="caption" fontWeight="regular" color="text">-</MDTypography>
                                        )}
                                    </DataTableBodyCell>
                                    <DataTableBodyCell isProcess={true}>
                                    <MDTypography 
                                        variant="caption" 
                                        fontWeight="regular" 
                                        color="text"
                                        title={item.descricao}
                                        sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 200, display: 'block' }}
                                    >
                                        {item.descricao || "-"}
                                    </MDTypography>
                                </DataTableBodyCell>
                                <DataTableBodyCell isProcess={true}>
                                    <MDTypography variant="caption" fontWeight="regular" color="text">{item.parcela}</MDTypography>
                                </DataTableBodyCell>
                                <DataTableBodyCell isProcess={true}>
                                    <MDTypography variant="caption" fontWeight="regular" color="text">{item.vencimento ? moment.utc(item.vencimento).format("DD/MM/YYYY") : ""}</MDTypography>
                                </DataTableBodyCell>
                                <DataTableBodyCell isProcess={true}>
                                    <MDTypography variant="caption" fontWeight="regular" color="text">{toCurrency(item.saldo)}</MDTypography>
                                </DataTableBodyCell>
                                <DataTableBodyCell isProcess={true}>
                                    <MDTypography variant="caption" fontWeight="regular" color="text">{getSituacaoLabel(item.situacao)}</MDTypography>
                                </DataTableBodyCell>
                                {(!isViewOnly || recordId) && (
                                    <DataTableBodyCell align="center" isProcess={true}>
                                        {!isViewOnly && (
                                            <>
                                                <IconButton color="info" size="small" onClick={() => handleOpenDialog(item)} sx={{ p: 0.5 }}>
                                                    <Icon fontSize="small">edit</Icon>
                                                </IconButton>
                                                <IconButton color="error" size="small" onClick={() => handleDeleteClick(item)} sx={{ p: 0.5, ml: 1 }}>
                                                    <Icon fontSize="small">delete</Icon>
                                                </IconButton>
                                            </>
                                        )}
                                        {recordId && item.situacao !== 4 && (
                                            isAdminOrSuporte ? (
                                                <IconButton color="error" size="small" onClick={() => handleDevolverDireto(item)} sx={{ p: 0.5, ml: 1 }} title="Devolver Contrato" disabled={isFichaDevolvida}>
                                                    <Icon fontSize="small">assignment_return</Icon>
                                                </IconButton>
                                            ) : (
                                                <IconButton color="warning" size="small" onClick={() => handleOpenSolicitarDevolucao(item)} sx={{ p: 0.5, ml: 1 }} title="Solicitar Devolução" disabled={isFichaDevolvida}>
                                                    <Icon fontSize="small">assignment_return</Icon>
                                                </IconButton>
                                            )
                                        )}
                                        {recordId && item.situacao === 4 && isAdminOrSuporte && (
                                            <IconButton color="success" size="small" onClick={() => handleReativarContratoDireto(item)} sx={{ p: 0.5, ml: 1 }} title="Reativar Contrato" disabled={isFichaDevolvida}>
                                                <Icon fontSize="small">restore</Icon>
                                            </IconButton>
                                        )}
                                    </DataTableBodyCell>
                                )}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            
            {contratosFiltrados.length > 0 && (
                <TablePagination
                    component="div"
                    count={contratosFiltrados.length}
                    page={page}
                    onPageChange={(e, newPage) => setPage(newPage)}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={(e) => {
                        setRowsPerPage(parseInt(e.target.value, 10));
                        setPage(0);
                    }}
                    labelRowsPerPage="Itens por pág:"
                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    sx={{
                        ".MuiTablePagination-toolbar": { minHeight: 36, paddingLeft: 1, paddingRight: 1 },
                        ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows": { fontSize: "0.75rem", margin: 0 },
                        ".MuiTablePagination-select": { fontSize: "0.75rem" }
                    }}
                />
            )}

            <MDBox mt={3} p={2} bgcolor="background.default" borderRadius={2} border="1px solid" borderColor="divider">
                <Grid container spacing={2} alignItems="flex-end">
                    <Grid item xs={12} sm={4} md={3}>
                        <MDInput
                            type="date"
                            label="Data Base para Simulação"
                            name="dataBaseSimulacao"
                            value={dataBaseSimulacao}
                            onChange={(e) => setDataBaseSimulacao(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                        <MDButton 
                            variant="contained" 
                            color="success" 
                            size="medium" 
                            fullWidth
                            onClick={() => handleSimularCalculoDevedor()} 
                            disabled={simulacaoLoading || contratos.length === 0}
                        >
                            <Icon sx={{ mr: 1 }}>calculate</Icon> Simular Ficha Completa
                        </MDButton>
                    </Grid>
                </Grid>
            </MDBox>

            <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
                <DialogTitle>{selectedContrato ? "Editar Contrato" : "Novo Contrato"}</DialogTitle>
                <Formik
                    initialValues={{
                        id: selectedContrato?.id || "",
                        titulo: selectedContrato?.titulo || "",
                        descricao: selectedContrato?.descricao || "",
                        parcela: selectedContrato?.parcela || "Única",
                        vencimento: selectedContrato?.vencimento ? moment.utc(selectedContrato.vencimento).format("YYYY-MM-DD") : "",
                        valorOriginal: selectedContrato?.valorOriginal ? formatCurrencyInput(selectedContrato.valorOriginal) : "",
                        saldo: selectedContrato?.saldo ? formatCurrencyInput(selectedContrato.saldo) : "",
                        situacao: selectedContrato?.situacao || 1,
                        marcacoesIds: selectedContrato?.marcacoesIds || [],
                        carteiraId: selectedContrato?.idCarteira || (carteirasOptions.length === 1 ? carteirasOptions[0].id : ""),
                    }}
                    onSubmit={handleSubmit}
                    enableReinitialize
                >
                    {({ values, handleChange, setFieldValue, isSubmitting }) => (
                        <Form>
                            <DialogContent dividers>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={4}>
                                        <FormField
                                            type="text"
                                            label="Título"
                                            name="titulo"
                                            value={values.titulo}
                                            onChange={handleChange}
                                            placeholder="Ex: Nota Fiscal 123"
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={2}>
                                        <FormField
                                            type="text"
                                            label="Parcela"
                                            name="parcela"
                                            value={values.parcela}
                                            onChange={handleChange}
                                            placeholder="Ex: 01/12"
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <FormField
                                            type="date"
                                            label="Vencimento"
                                            name="vencimento"
                                            value={values.vencimento}
                                            onChange={handleChange}
                                            required
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <MDBox mb={2}>
                                            <MDTypography variant="button" fontWeight="regular" color="text">
                                                Situação
                                            </MDTypography>
                                            <MDInput
                                                select
                                                name="situacao"
                                                value={values.situacao}
                                                onChange={handleChange}
                                                fullWidth
                                                size="small"
                                            >
                                                <MenuItem value={1}>Aberto</MenuItem>
                                                <MenuItem value={2}>Baixado Parcial</MenuItem>
                                                <MenuItem value={3}>Liquidado</MenuItem>
                                                <MenuItem value={4}>Cancelado</MenuItem>
                                            </MDInput>
                                        </MDBox>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <MDBox mb={2}>
                                            <MDTypography variant="button" fontWeight="regular" color="text">
                                                Marcação Especial
                                            </MDTypography>
                                            <MDSelect
                                                isMulti={true}
                                                getOptionValue={(option) => option.cvId}
                                                getOptionLabel={(option) => option.ccNome}
                                                name="marcacoesIds"
                                                placeholder="Selecione as marcações..."
                                                value={marcacoes.filter(m => values.marcacoesIds && values.marcacoesIds.includes(m.cvId))}
                                                options={marcacoes}
                                                onChange={(selected) => {
                                                    const val = selected ? selected.map(s => s.cvId) : [];
                                                    setFieldValue("marcacoesIds", val);
                                                }}
                                                isDisabled={isViewOnly}
                                            />
                                        </MDBox>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <MDBox mb={2}>
                                            <MDTypography variant="button" fontWeight="regular" color="text">
                                                Carteira
                                            </MDTypography>
                                            <MDInput
                                                select
                                                name="carteiraId"
                                                value={values.carteiraId || ""}
                                                onChange={handleChange}
                                                fullWidth
                                                size="small"
                                                disabled={carteirasOptions.length === 1 || isViewOnly}
                                            >
                                                {carteirasOptions.map(c => (
                                                    <MenuItem key={c.id} value={c.id}>{c.nome}</MenuItem>
                                                ))}
                                            </MDInput>
                                        </MDBox>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormField
                                            type="text"
                                            label="Descrição do Débito"
                                            name="descricao"
                                            value={values.descricao}
                                            onChange={handleChange}
                                            placeholder="Ex: Confissão de dívida assinada..."
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FormField
                                            type="text"
                                            label="Valor Original"
                                            name="valorOriginal"
                                            value={values.valorOriginal}
                                            onChange={(e) => {
                                                const formatted = formatCurrencyInput(e.target.value);
                                                setFieldValue("valorOriginal", formatted);
                                                setFieldValue("saldo", formatted);
                                            }}
                                            placeholder="R$ 0,00"
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FormField
                                            type="text"
                                            label="Saldo"
                                            name="saldo"
                                            value={values.saldo}
                                            onChange={(e) => setFieldValue("saldo", formatCurrencyInput(e.target.value))}
                                            placeholder="R$ 0,00"
                                            required
                                        />
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <MDButton color="secondary" onClick={handleCloseDialog}>
                                    Cancelar
                                </MDButton>
                                <MDButton color="info" type="submit" disabled={isSubmitting}>
                                    Salvar
                                </MDButton>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>

            {/* Simulação Dialog */}
            <Dialog open={simulacaoOpen} onClose={() => setSimulacaoOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle sx={{ p: 2 }}>
                    <MDTypography variant="h6">Simulação de Campanha</MDTypography>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 2 }}>
                    {simulacaoData && (
                        <Grid container spacing={1}>
                            <Grid item xs={12} mb={1}>
                                {simulacaoData.devedorNome && (
                                    <MDTypography variant="h6" color="dark" fontWeight="medium">{simulacaoData.devedorNome}</MDTypography>
                                )}
                                <MDTypography variant="button" color="info" fontWeight="medium">Campanha Aplicada: {simulacaoData.campanhaNome}</MDTypography>
                                {simulacaoData.dataSimulacao ? (
                                    <MDTypography variant="caption" display="block" color="text">Simulação gerada para a data base: {simulacaoData.dataSimulacao}</MDTypography>
                                ) : (
                                    <MDTypography variant="caption" display="block" color="text">Atraso: {simulacaoData.atrasoDias} dias</MDTypography>
                                )}
                            </Grid>
                            
                            {simulacaoData.contratosCalculadosList && simulacaoData.contratosCalculadosList.length > 0 ? (
                                <Grid item xs={12} mb={1}>
                                    <MDTypography variant="caption" fontWeight="medium" mb={1} display="block">Detalhamento por Contrato</MDTypography>
                                    <TableContainer sx={{ border: "1px solid #f0f2f5", borderRadius: 2 }}>
                                        <Table size="small">
                                            <MDBox component="thead">
                                                <TableRow>
                                                    <DataTableHeadCell width="auto" sorted={false}>Contrato / Parc.</DataTableHeadCell>
                                                    <DataTableHeadCell width="auto" align="right" sorted={false}>Atraso</DataTableHeadCell>
                                                    <DataTableHeadCell width="auto" align="right" sorted={false}>Original</DataTableHeadCell>
                                                    <DataTableHeadCell width="auto" align="right" sorted={false}>Correção</DataTableHeadCell>
                                                    <DataTableHeadCell width="auto" align="right" sorted={false}>Multa</DataTableHeadCell>
                                                    <DataTableHeadCell width="auto" align="right" sorted={false}>Juros</DataTableHeadCell>
                                                    <DataTableHeadCell width="auto" align="right" sorted={false}>Honorários</DataTableHeadCell>
                                                    <DataTableHeadCell width="auto" align="right" sorted={false}>Atualizado</DataTableHeadCell>
                                                </TableRow>
                                            </MDBox>
                                            <TableBody>
                                                {simulacaoData.contratosCalculadosList.map((c, idx) => (
                                                    <TableRow key={idx}>
                                                        <DataTableBodyCell isProcess={true}>
                                                            <MDTypography variant="caption" color="dark">{c.titulo} {c.parcela && c.parcela !== "Única" ? `(${c.parcela})` : ''}</MDTypography>
                                                        </DataTableBodyCell>
                                                        <DataTableBodyCell align="right" isProcess={true}>
                                                            <MDTypography variant="caption" color="dark">{c.atrasoDias} dias</MDTypography>
                                                        </DataTableBodyCell>
                                                        <DataTableBodyCell align="right" isProcess={true}>
                                                            <MDTypography variant="caption" color="dark">{toCurrency(c.valorOriginal)}</MDTypography>
                                                        </DataTableBodyCell>
                                                        <DataTableBodyCell align="right" isProcess={true}>
                                                            <MDTypography variant="caption" color="warning">+{toCurrency(c.valorCorrecao || 0)}</MDTypography>
                                                        </DataTableBodyCell>
                                                        <DataTableBodyCell align="right" isProcess={true}>
                                                            <MDTypography variant="caption" color="error">+{toCurrency(c.valorMulta)}</MDTypography>
                                                        </DataTableBodyCell>
                                                        <DataTableBodyCell align="right" isProcess={true}>
                                                            <MDTypography variant="caption" color="error">+{toCurrency(c.valorJuros)}</MDTypography>
                                                        </DataTableBodyCell>
                                                        <DataTableBodyCell align="right" isProcess={true}>
                                                            <MDTypography variant="caption" color="error">+{toCurrency(c.valorHonorarios)}</MDTypography>
                                                        </DataTableBodyCell>
                                                        <DataTableBodyCell align="right" isProcess={true}>
                                                            <MDTypography variant="caption" fontWeight="medium" color="dark">{toCurrency(c.totalAtualizado)}</MDTypography>
                                                        </DataTableBodyCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            ) : (
                                <>
                                    <Grid item xs={6} md>
                                        <MDTypography variant="caption" color="text">Valor Original</MDTypography>
                                        <MDTypography variant="caption" display="block" fontWeight="bold" color="dark">{toCurrency(simulacaoData.valorOriginal)}</MDTypography>
                                    </Grid>
                                    <Grid item xs={6} md>
                                        <MDTypography variant="caption" color="text">Correção Monetária</MDTypography>
                                        <MDTypography variant="caption" display="block" fontWeight="bold" color="warning">+{toCurrency(simulacaoData.valorCorrecao || 0)}</MDTypography>
                                    </Grid>
                                    <Grid item xs={6} md>
                                        <MDTypography variant="caption" color="text">Multa ({simulacaoData.multaPercentual}%)</MDTypography>
                                        <MDTypography variant="caption" display="block" fontWeight="bold" color="error">+{toCurrency(simulacaoData.valorMulta)}</MDTypography>
                                    </Grid>
                                    <Grid item xs={6} md>
                                        <MDTypography variant="caption" color="text">Juros ({simulacaoData.jurosMensalPercentual}% a.m.)</MDTypography>
                                        <MDTypography variant="caption" display="block" fontWeight="bold" color="error">+{toCurrency(simulacaoData.valorJuros)}</MDTypography>
                                    </Grid>
                                    <Grid item xs={6} md>
                                        <MDTypography variant="caption" color="text">Honorários ({simulacaoData.honorariosPercentual}%)</MDTypography>
                                        <MDTypography variant="caption" display="block" fontWeight="bold" color="error">+{toCurrency(simulacaoData.valorHonorarios)}</MDTypography>
                                    </Grid>
                                </>
                            )}
                            
                            <Grid item xs={12}>
                                <MDBox p={1} bgcolor="#f0f2f5" borderRadius={1} mt={1} display="flex" justifyContent="space-between" alignItems="center">
                                    <MDTypography variant="button" fontWeight="medium" color="dark">Total Atualizado</MDTypography>
                                    <MDTypography variant="button" fontWeight="bold" color="dark">{toCurrency(simulacaoData.totalAtualizado)}</MDTypography>
                                </MDBox>
                            </Grid>

                            {simulacaoData.opcoesParcelamento && simulacaoData.opcoesParcelamento.length > 0 && (
                                <Grid item xs={12} mt={2}>
                                    <MDTypography variant="caption" fontWeight="medium" mb={1} display="block">Opções de Parcelamento</MDTypography>
                                    <TableContainer sx={{ boxShadow: "none" }}>
                                        <Table size="small">
                                            <MDBox component="thead">
                                                <TableRow>
                                                    <DataTableHeadCell width="auto" sorted={false}>Parcelas</DataTableHeadCell>
                                                    <DataTableHeadCell width="auto" sorted={false}>Desc. Principal</DataTableHeadCell>
                                                    <DataTableHeadCell width="auto" sorted={false}>Desc. Juros</DataTableHeadCell>
                                                    <DataTableHeadCell width="auto" sorted={false}>Desc. Multa</DataTableHeadCell>
                                                    <DataTableHeadCell width="auto" sorted={false}>Desc. Honorários</DataTableHeadCell>
                                                    <DataTableHeadCell width="auto" align="right" sorted={false}>Total a Pagar</DataTableHeadCell>
                                                    <DataTableHeadCell width="auto" align="center" sorted={false}>Ação</DataTableHeadCell>
                                                </TableRow>
                                            </MDBox>
                                            <TableBody>
                                                {simulacaoData.opcoesParcelamento.map((p, i) => (
                                                    <TableRow key={i}>
                                                        <DataTableBodyCell isProcess={true}>
                                                            <MDTypography variant="caption" color="text">{p.parcelaMinima} a {p.parcelaMaxima}x</MDTypography>
                                                        </DataTableBodyCell>
                                                        <DataTableBodyCell isProcess={true}>
                                                            <MDTypography variant="caption" color="text">{p.descontoPrincipal}%</MDTypography>
                                                        </DataTableBodyCell>
                                                        <DataTableBodyCell isProcess={true}>
                                                            <MDTypography variant="caption" color="text">{p.descontoJuros}%</MDTypography>
                                                        </DataTableBodyCell>
                                                        <DataTableBodyCell isProcess={true}>
                                                            <MDTypography variant="caption" color="text">{p.descontoMulta}%</MDTypography>
                                                        </DataTableBodyCell>
                                                        <DataTableBodyCell isProcess={true}>
                                                            <MDTypography variant="caption" color="text">{p.descontoHonorarios}%</MDTypography>
                                                        </DataTableBodyCell>
                                                        <DataTableBodyCell align="right" isProcess={true}>
                                                            <MDTypography variant="caption" fontWeight="bold" color="dark">{toCurrency(p.totalComDesconto)}</MDTypography>
                                                        </DataTableBodyCell>
                                                        <DataTableBodyCell align="center" isProcess={true}>
                                                            <MDButton size="small" color="info" variant="outlined" onClick={() => handleOpenAcordoModal(p)}>
                                                                Gerar
                                                            </MDButton>
                                                        </DataTableBodyCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    
                                    <MDBox mt={2} display="flex" justifyContent="center">
                                        <MDButton size="small" color="secondary" variant="outlined" onClick={handleOpenAcordoManual}>
                                            Nova Simulação Manual
                                        </MDButton>
                                    </MDBox>
                                </Grid>
                            )}
                        </Grid>
                    )}
                </DialogContent>
                <DialogActions sx={{ p: 1 }}>
                    <MDButton size="small" color="secondary" onClick={() => setSimulacaoOpen(false)}>Fechar</MDButton>
                </DialogActions>
            </Dialog>

            {/* Gerar Acordo Dialog */}
            <Dialog open={acordoModalOpen} onClose={() => setAcordoModalOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle>Gerar Acordo / Cronograma</DialogTitle>
                <DialogContent dividers>
                    {acordoOpcaoSelecionada && (() => {
                        const isAvista = !acordoOpcaoSelecionada.isManual && acordoOpcaoSelecionada.parcelaMaxima === 1 && acordoOpcaoSelecionada.parcelaMinima === 1;
                        return (
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                {acordoOpcaoSelecionada.isManual ? (
                                    <MDBox display="flex" justifyContent="space-between" alignItems="center">
                                        <MDInput 
                                            type="text" 
                                            label="Valor Total Negociado" 
                                            value={acordoValorManual} 
                                            onChange={(e) => setAcordoValorManual(formatCurrencyInput(e.target.value))} 
                                            sx={{ minWidth: 200 }} 
                                        />
                                        <FormControlLabel
                                            control={<Switch checked={acordoIsExcecao} onChange={(e) => setAcordoIsExcecao(e.target.checked)} color="error" />}
                                            label={<MDTypography variant="caption" color="error">Liberar como Exceção</MDTypography>}
                                        />
                                    </MDBox>
                                ) : (
                                    <MDTypography variant="body2" color="text">
                                        Valor Total do Acordo: <b>{toCurrency(acordoOpcaoSelecionada.totalComDesconto)}</b>
                                    </MDTypography>
                                )}
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <MDTypography variant="caption" color="text" display="block">Forma de Pagamento</MDTypography>
                                <Select
                                    value={acordoFormaPagamento}
                                    onChange={(e) => setAcordoFormaPagamento(e.target.value)}
                                    fullWidth
                                    size="small"
                                >
                                    <MenuItem value="Boleto">Boleto</MenuItem>
                                    <MenuItem value="Pix">Pix</MenuItem>
                                    <MenuItem value="Depósito">Depósito/Transferência</MenuItem>
                                    <MenuItem value="Cartão de Crédito">Cartão de Crédito</MenuItem>
                                    <MenuItem value="Dinheiro">Dinheiro</MenuItem>
                                </Select>
                            </Grid>
                            
                            {isAvista ? (
                                <Grid item xs={12} sm={6}>
                                    <MDInput type="date" label="Data do Vencimento" value={acordoPrimeiroVencimento} onChange={(e) => setAcordoPrimeiroVencimento(e.target.value)} InputLabelProps={{ shrink: true }} fullWidth />
                                </Grid>
                            ) : (
                                <>
                                    <Grid item xs={12}>
                                        <FormControlLabel
                                            control={<Switch checked={acordoComEntrada} onChange={(e) => setAcordoComEntrada(e.target.checked)} color="info" />}
                                            label={<MDTypography variant="caption" color="text">Possui Pagamento de Entrada?</MDTypography>}
                                        />
                                    </Grid>
                                    
                                    {acordoComEntrada && (
                                        <>
                                            <Grid item xs={12} sm={parseInt(acordoQtdEntrada) > 1 ? 4 : 3}>
                                                <MDInput type="text" label="Valor Entrada" value={acordoValorEntrada} onChange={(e) => handleMainValorEntradaChange(e.target.value)} fullWidth />
                                            </Grid>
                                            <Grid item xs={12} sm={parseInt(acordoQtdEntrada) > 1 ? 4 : 3}>
                                                <MDInput type="number" label="Qtd Parcelas da Entrada" value={acordoQtdEntrada} onChange={(e) => setAcordoQtdEntrada(Math.max(1, parseInt(e.target.value) || 1))} fullWidth />
                                            </Grid>
                                            <Grid item xs={12} sm={parseInt(acordoQtdEntrada) > 1 ? 4 : 3}>
                                                <MDInput type="date" label="Vencimento Entrada" value={acordoVencimentoEntrada} onChange={(e) => setAcordoVencimentoEntrada(e.target.value)} InputLabelProps={{ shrink: true }} fullWidth />
                                            </Grid>
                                            {parseInt(acordoQtdEntrada) === 1 && (
                                                <Grid item xs={12} sm={3} display="flex" alignItems="center">
                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                checked={acordoMleList[0] || false}
                                                                onChange={(e) => {
                                                                    setAcordoMleList([e.target.checked]);
                                                                }}
                                                                color="info"
                                                            />
                                                        }
                                                        label={<MDTypography variant="caption" color="text">MLE</MDTypography>}
                                                    />
                                                </Grid>
                                            )}

                                            {parseInt(acordoQtdEntrada) > 1 && acordoEntradasDetalhadas.length > 0 && (
                                                <Grid item xs={12}>
                                                    <MDTypography variant="caption" fontWeight="medium" display="block" mb={1} sx={{ opacity: 0.8 }}>
                                                        Detalhamento das Parcelas de Entrada:
                                                    </MDTypography>
                                                    <Grid container spacing={2} sx={{ pl: 2, borderLeft: "3px solid #1A73E8", my: 1 }}>
                                                        {acordoEntradasDetalhadas.map((ent, idx) => (
                                                            <React.Fragment key={idx}>
                                                                <Grid item xs={12} sm={3} display="flex" alignItems="center">
                                                                    <MDTypography variant="button" fontWeight="medium" size="small">
                                                                        Entrada {idx + 1}
                                                                    </MDTypography>
                                                                </Grid>
                                                                <Grid item xs={12} sm={3}>
                                                                    <MDInput
                                                                        type="text"
                                                                        label="Valor"
                                                                        value={ent.valor}
                                                                        onChange={(e) => {
                                                                            let newList = [...acordoEntradasDetalhadas];
                                                                            newList[idx].valor = formatCurrencyInput(e.target.value);
                                                                            setAcordoEntradasDetalhadas(newList);
                                                                            
                                                                            // Recalculate total entry
                                                                            let sum = 0;
                                                                            for (let item of newList) {
                                                                                sum += (formatUncurrency(item.valor) || 0);
                                                                            }
                                                                            setAcordoValorEntrada(formatCurrencyInput(sum));
                                                                        }}
                                                                        fullWidth
                                                                        size="small"
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12} sm={3}>
                                                                    <MDInput
                                                                        type="date"
                                                                        label="Vencimento"
                                                                        value={ent.vencimento}
                                                                        onChange={(e) => {
                                                                            let newList = [...acordoEntradasDetalhadas];
                                                                            newList[idx].vencimento = e.target.value;
                                                                            setAcordoEntradasDetalhadas(newList);
                                                                        }}
                                                                        InputLabelProps={{ shrink: true }}
                                                                        fullWidth
                                                                        size="small"
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12} sm={3} display="flex" alignItems="center">
                                                                    <FormControlLabel
                                                                        control={
                                                                            <Switch
                                                                                checked={acordoMleList[idx] || false}
                                                                                onChange={(e) => {
                                                                                    const newMle = [...acordoMleList];
                                                                                    newMle[idx] = e.target.checked;
                                                                                    setAcordoMleList(newMle);
                                                                                }}
                                                                                color="info"
                                                                            />
                                                                        }
                                                                        label={<MDTypography variant="caption" color="text">MLE</MDTypography>}
                                                                    />
                                                                </Grid>
                                                            </React.Fragment>
                                                        ))}
                                                    </Grid>
                                                </Grid>
                                            )}
                                        </>
                                    )}
                                    
                                    <Grid item xs={12} sm={3}>
                                        <MDInput type="number" label="Periodicidade (dias)" value={acordoPeriodicidade} onChange={(e) => setAcordoPeriodicidade(e.target.value)} fullWidth />
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <MDInput type="number" label="Qtd. Restante (Parcelas)" value={acordoQtdParcelas} onChange={(e) => setAcordoQtdParcelas(Math.max(0, Math.min(acordoOpcaoSelecionada.parcelaMaxima, e.target.value)))} inputProps={{ max: acordoOpcaoSelecionada.parcelaMaxima }} fullWidth />
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <MDInput type="date" label={acordoComEntrada ? "Venc. Restante" : "Primeiro Vencimento"} value={acordoPrimeiroVencimento} onChange={(e) => setAcordoPrimeiroVencimento(e.target.value)} InputLabelProps={{ shrink: true }} fullWidth />
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <MDButton variant="outlined" color="info" fullWidth onClick={handleCalcularCronograma} sx={{ height: '100%' }}>
                                            Calcular
                                        </MDButton>
                                    </Grid>
                                    
                                    {acordoParcelasGeradas.length > 0 && (
                                        <Grid item xs={12}>
                                            <MDTypography variant="caption" fontWeight="medium" display="block" mb={1} mt={2}>Cronograma de Pagamento Gerado:</MDTypography>
                                            <TableContainer component={Paper} variant="outlined" sx={{ boxShadow: "none", maxHeight: 300 }}>
                                                <Table size="small" stickyHeader>
                                                    <TableHead sx={{ display: "table-header-group" }}>
                                                        <TableRow>
                                                            <TableCell><MDTypography variant="caption" color="text" fontWeight="medium">Nº</MDTypography></TableCell>
                                                            <TableCell><MDTypography variant="caption" color="text" fontWeight="medium">Tipo</MDTypography></TableCell>
                                                            <TableCell><MDTypography variant="caption" color="text" fontWeight="medium">Vencimento</MDTypography></TableCell>
                                                            <TableCell><MDTypography variant="caption" color="text" fontWeight="medium">Valor</MDTypography></TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {acordoParcelasGeradas.map((p, pIdx) => (
                                                            <TableRow key={pIdx}>
                                                                <TableCell><MDTypography variant="caption">{p.numeroParcela}</MDTypography></TableCell>
                                                                <TableCell><MDTypography variant="caption" color={p.isEntrada ? "success" : "text"}>{p.isEntrada ? (p.isMle ? "Entrada (MLE)" : "Entrada") : "Parcela"}</MDTypography></TableCell>
                                                                <TableCell>
                                                                    <MDInput 
                                                                        type="date" 
                                                                        size="small"
                                                                        value={p.vencimento} 
                                                                        onChange={(e) => handleChangeParcela(pIdx, 'vencimento', e.target.value)} 
                                                                        sx={{ minWidth: 130 }}
                                                                    />
                                                                </TableCell>
                                                                <TableCell>
                                                                    <MDInput 
                                                                        type="text" 
                                                                        size="small"
                                                                        value={typeof p.valorParcela === 'number' ? formatCurrencyInput(p.valorParcela) : p.valorParcela} 
                                                                        onChange={(e) => handleChangeParcela(pIdx, 'valorParcela', formatCurrencyInput(e.target.value))} 
                                                                        sx={{ minWidth: 120 }}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Grid>
                                    )}
                                </>
                            )}
                            
                            {/* Honorários Section */}
                            {!isHonorariosTab && (() => {
                                const allowsHO = contratos.some(c => (selectedContratos.length === 0 || selectedContratos.includes(c.id)) && c.permiteGerarHonorario);
                                if (!allowsHO) return null;
                                return (
                                    <Grid item xs={12}>
                                        <MDBox mt={2} p={2} bgcolor="background.default" borderRadius={2} border="1px dashed" borderColor="divider">
                                            <FormControlLabel
                                                control={<Switch checked={gerarHO} onChange={(e) => setGerarHO(e.target.checked)} color="info" />}
                                                label={<MDTypography variant="button" fontWeight="medium" color="dark">Gerar Dívida de Honorários Advocatícios sobre o Acordo?</MDTypography>}
                                            />
                                            {gerarHO && (
                                                <Grid container spacing={2} mt={1}>
                                                    <Grid item xs={12} sm={6}>
                                                        <MDInput
                                                            type="number"
                                                            label="Percentual (%) sobre o Acordo"
                                                            value={hoPercentual}
                                                            onChange={(e) => setHoPercentual(e.target.value)}
                                                            fullWidth
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <MDTypography variant="caption" color="text" display="block">Tipo de Honorário</MDTypography>
                                                        <Select
                                                            value={hoTipo}
                                                            onChange={(e) => setHoTipo(e.target.value)}
                                                            fullWidth
                                                            size="small"
                                                        >
                                                            {hoTiposList.map((t) => (
                                                                <MenuItem key={t.id} value={t.id}>
                                                                    {t.label}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </Grid>
                                                </Grid>
                                            )}
                                        </MDBox>
                                    </Grid>
                                );
                            })()}
                            
                        </Grid>
                        );
                    })()}
                </DialogContent>
                <DialogActions>
                    <MDButton color="secondary" onClick={() => setAcordoModalOpen(false)}>Cancelar</MDButton>
                    <MDButton color="success" onClick={handleGerarAcordo} disabled={acordoLoading}>
                        Confirmar e Gerar
                    </MDButton>
                </DialogActions>
            </Dialog>

            <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
                <DialogTitle>Confirmar Exclusão</DialogTitle>
                <DialogContent>
                    Tem certeza que deseja excluir o contrato <strong>{contratoToDelete?.titulo}</strong>?
                    <br/><br/>
                    <MDTypography variant="caption" color="error">
                        Atenção: Esta ação não poderá ser desfeita e pode afetar acordos vinculados.
                    </MDTypography>
                </DialogContent>
                <DialogActions>
                    <MDButton onClick={() => setDeleteDialogOpen(false)} color="secondary">
                        Cancelar
                    </MDButton>
                    <MDButton onClick={confirmDelete} color="error" variant="contained">
                        Excluir
                    </MDButton>
                </DialogActions>
            </Dialog>

            <MDSnackbar
                color="success"
                icon="check"
                title="Sucesso"
                content={sbMessage}
                open={successSB}
                onClose={() => setSuccessSB(false)}
                close={() => setSuccessSB(false)}
                bgWhite
            />
            <MDSnackbar
                color="error"
                icon="warning"
                title="Erro"
                content={sbMessage}
                open={errorSB}
                onClose={() => setErrorSB(false)}
                close={() => setErrorSB(false)}
                bgWhite
            />
            {/* Modal Confirmação Cancelamento */}
            <Dialog open={confirmCancelOpen} onClose={() => setConfirmCancelOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Atenção! Acordo Ativo Encontrado</DialogTitle>
                <DialogContent>
                    <MDTypography variant="body2" color="text">
                        Esta ficha já possui um Acordo Ativo. Deseja iniciar uma nova simulação?<br /><br />
                        <b>Nota:</b> O acordo atual só será efetivamente cancelado no sistema quando você finalizar a nova negociação clicando em "Confirmar e Gerar".
                    </MDTypography>
                </DialogContent>
                <DialogActions>
                    <MDButton onClick={() => setConfirmCancelOpen(false)} color="secondary">Voltar</MDButton>
                    <MDButton onClick={() => {
                        setConfirmCancelOpen(false);
                        if (pendingOpcao && pendingOpcao.isManual) {
                            proceedOpenAcordoManual();
                        } else {
                            proceedOpenAcordoModal(pendingOpcao);
                        }
                    }} color="info">Continuar e Simular Novo</MDButton>
                </DialogActions>
            </Dialog>

            {/* Migração Modal */}
            <Dialog open={migracaoModalOpen} onClose={() => setMigracaoModalOpen(false)} maxWidth="xs" fullWidth>
                <DialogTitle>Migrar Contratos Selecionados</DialogTitle>
                <DialogContent>
                    <MDTypography variant="body2" color="text" mb={2}>
                        Selecione as opções de destino para os {selectedContratos.length} contratos selecionados:
                    </MDTypography>
                    <MDInput
                        select
                        fullWidth
                        label="Carteira de Destino"
                        value={selectedCarteiraMigracao}
                        onChange={(e) => setSelectedCarteiraMigracao(e.target.value)}
                        sx={{ mb: 2 }}
                    >
                        <MenuItem value="">Selecione...</MenuItem>
                        {carteirasOptions.map((c, i) => (
                            <MenuItem key={i} value={c.id || c.cvId}>{c.nome || c.ccNome}</MenuItem>
                        ))}
                    </MDInput>
                    <MDInput
                        select
                        fullWidth
                        label="Proprietário da Ficha (Opcional)"
                        value={selectedUsuarioMigracao}
                        onChange={(e) => setSelectedUsuarioMigracao(e.target.value)}
                        sx={{ mb: 2 }}
                    >
                        <MenuItem value="">Nenhum</MenuItem>
                        {usuariosOptions.map((c, i) => (
                            <MenuItem key={i} value={c.id || c.cvId}>{c.nome || c.ccNome}</MenuItem>
                        ))}
                    </MDInput>
                    <MDInput
                        select
                        fullWidth
                        label="Status da Ficha (Opcional)"
                        value={selectedStatusMigracao}
                        onChange={(e) => setSelectedStatusMigracao(e.target.value)}
                    >
                        <MenuItem value="">Em aberto (Padrão)</MenuItem>
                        {statusFichaOptions.map((c, i) => (
                            <MenuItem key={i} value={c.id || c.cvId}>{c.nome || c.ccNome}</MenuItem>
                        ))}
                    </MDInput>
                </DialogContent>
                <DialogActions>
                    <MDButton color="secondary" onClick={() => setMigracaoModalOpen(false)}>Cancelar</MDButton>
                    <MDButton color="info" onClick={handleConfirmMigracao}>Migrar</MDButton>
                </DialogActions>
            </Dialog>

            {!isViewOnly && formRef && (
                <Grid container spacing={3} mt={2}>
                    <Grid item xs={12} display="flex" justifyContent="flex-end">
                        <MDButton variant="gradient" color="info" disabled={isSavingForm || formRef.current?.isSubmitting} onClick={async () => {
                            if (formRef.current) {
                                setIsSavingForm(true);
                                const errors = await formRef.current.validateForm();
                                if (Object.keys(errors).length > 0) {
                                    formRef.current.setTouched(
                                        Object.keys(errors).reduce((acc, curr) => ({ ...acc, [curr]: true }), {})
                                    );
                                    alert("Existem campos obrigatórios na aba Cadastro Básico que não foram preenchidos.");
                                    setIsSavingForm(false);
                                    return;
                                }
                                formRef.current.submitForm().finally(() => setIsSavingForm(false));
                            }
                        }}>
                            Salvar Cadastro
                        </MDButton>
                    </Grid>
                </Grid>
            )}
            {/* Devolução Modal */}
            <Dialog open={openDevolverModal} onClose={() => !isSubmittingDevolucao && setOpenDevolverModal(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Solicitar Devolução de Contrato/Título</DialogTitle>
                <DialogContent>
                    <MDBox mt={2}>
                        <MDTypography variant="body2" color="text" mb={2}>
                            <strong>Contrato:</strong> {contratoParaDevolver?.titulo || "-"}
                        </MDTypography>
                        <MDInput
                            label="Motivo / Observação"
                            multiline
                            rows={4}
                            fullWidth
                            value={devolverObs}
                            onChange={(e) => setDevolverObs(e.target.value)}
                            disabled={isSubmittingDevolucao}
                            required
                        />
                    </MDBox>
                    <MDBox mt={2}>
                        <MDTypography variant="caption" fontWeight="bold">Anexar Arquivo (Opcional)</MDTypography>
                        <input
                            type="file"
                            onChange={(e) => setDevolverFile(e.target.files[0])}
                            disabled={isSubmittingDevolucao}
                            style={{ display: "block", marginTop: "8px" }}
                        />
                    </MDBox>
                </DialogContent>
                <DialogActions>
                    <MDButton onClick={() => setOpenDevolverModal(false)} color="secondary" disabled={isSubmittingDevolucao}>Cancelar</MDButton>
                    <MDButton 
                        onClick={async () => {
                            if (!devolverObs) {
                                alert("Preencha o motivo/observação.");
                                return;
                            }
                            setIsSubmittingDevolucao(true);
                            try {
                                await postNoResponse(`/contratos/solicitar-devolucao/${contratoParaDevolver.id}`, { observacao: devolverObs });
                                if (devolverFile) {
                                    const formData = new FormData();
                                    formData.append("file", devolverFile);
                                    await postUploadNoResponse(`/document/devedor/upload/${recordId}`, formData);
                                }
                                setOpenDevolverModal(false);
                                showSnackbar("Solicitação de devolução enviada com sucesso!", true);
                                setIsSubmittingDevolucao(false);
                                fetchContratos();
                            } catch (e) {
                                showSnackbar("Erro ao solicitar devolução do contrato.", false);
                                setIsSubmittingDevolucao(false);
                            }
                        }} 
                        color="primary" 
                        disabled={isSubmittingDevolucao}
                    >
                        {isSubmittingDevolucao ? "Enviando..." : "Enviar Solicitação"}
                    </MDButton>
                </DialogActions>
            </Dialog>

            <Dialog open={confirmAction.open} onClose={() => setConfirmAction({ ...confirmAction, open: false })} maxWidth="xs" fullWidth>
                <DialogTitle>{confirmAction.title}</DialogTitle>
                <DialogContent>
                    <MDTypography variant="body2">{confirmAction.message}</MDTypography>
                </DialogContent>
                <DialogActions>
                    <MDButton onClick={() => setConfirmAction({ ...confirmAction, open: false })} color="secondary">Cancelar</MDButton>
                    <MDButton onClick={() => {
                        if (confirmAction.onConfirm) confirmAction.onConfirm();
                        setConfirmAction({ ...confirmAction, open: false });
                    }} color="info">OK</MDButton>
                </DialogActions>
            </Dialog>
        </MDBox>
    );
}
